import { Container, Typography } from '@mui/material'
import { format } from 'date-fns'
import { useNavigate } from 'react-router'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import { Spinner } from 'src/components/MUIBased/icons'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { useOpenLoopAppointments } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/hooks/useOpenLoopAppointments'

const BookingConfirmation = () => {
    const { isLoading, appointments } = useOpenLoopAppointments({
        serviceLine: 'mwl'
    })
    const navigate = useNavigate()

    if (isLoading) {
        return <Spinner />
    }

    if (!appointments || appointments.length === 0) {
        navigate('/customized-weight-management-subscription/payment')
        return null
    }

    const appointment = appointments[0]

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading href="/" showBackButton={false}>
                Customized Weight Management
            </NavBarHeading>

            <Container>
                <ContainerTitle
                    title="Appointment Booked"
                    description="Your appointment has been successfully booked. Please save the following for your records:"
                />

                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Appointment ID
                </Typography>
                <Typography variant="h4" sx={{ mb: 2 }}>
                    {appointment.id}
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Date
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {format(
                        new Date(appointment.date),
                        'MMMM d, yyyy h:mm a'
                    ).toUpperCase()}
                </Typography>
            </Container>
        </Body>
    )
}

export default BookingConfirmation
